'use client';

import { NotFoundPage } from '@/components/NotFoundPage';

export default function NotFound() {
  return <NotFoundPage />;
}
